import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const REQUIREMENTS = ["LELAKI / PEREMPUAN", "18 TAHUN KE ATAS", "BEBAS REKOD JENAYAH", "SIHAT TUBUH BADAN"];

export function RequirementsSection() {
  return (
    <section id="syarat" data-testid="kursus-requirements" className="bg-kursus-bg2 py-20 sm:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-anton uppercase text-4xl sm:text-6xl text-kursus-white leading-none"
        >
          SYARAT<br /><span className="text-kursus-gold">-SYARAT</span>
        </motion.h2>

        <div>
          {REQUIREMENTS.map((r, i) => (
            <motion.div
              key={r}
              initial={{ opacity: 0, x: 16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              data-testid={`kursus-requirement-${i}`}
            >
              <div className="flex items-center gap-3.5 py-4">
                <CheckCircle2 className="w-5 h-5 text-kursus-gold shrink-0" />
                <span className="font-oswald text-base sm:text-lg text-kursus-white tracking-wide">{r}</span>
              </div>
              {i < REQUIREMENTS.length - 1 && <div className="h-px bg-kursus-red/40" />}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
